module.exports = __webpack_public_path__ + "static/media/img_logo_galicia_2.b3502f34.png";